module.exports = __webpack_public_path__ + "media/images/landing/client_Expedia-06ae109ae31bf394ee019589e99e27f8.png";